import {UserStatus} from "../../model/user-model";


export function isProcessing(pageStatus: UserStatus): boolean {
  return pageStatus === "Unknow";
}
export function isNotLoggedIn(pageStatus: UserStatus): boolean {
  return pageStatus === "NotLoggedIn";
}
export function isErrored(pageStatus: UserStatus): boolean {
  return pageStatus === "Error";
}
export function isLoggedIn(pageStatus: UserStatus): boolean {
  return pageStatus === "LoggedIn";
}
